import { EntityDeleteInput } from 'common/types/globalTypes';
import { differenceBy } from 'lodash';
import { WorkgroupGroupRow } from '../../list';
import { WORKGROUP_INITIAL_VALUES } from './constants';
import { WorkgroupGroupItemsValues, WorkgroupGroupValues } from './types';
import { WorkgroupGroups_workgroupGroups_nodes_workgroupGroupItems_nodes } from '../../list/__generated__/WorkgroupGroups';

interface DefaultValueProps {
  isEdit: boolean;
  workgroupGroup: WorkgroupGroupRow | undefined;
}
type WorkgroupGroupItems =
  WorkgroupGroups_workgroupGroups_nodes_workgroupGroupItems_nodes;
interface GroupItemsProps {
  workgroupGroupItems: WorkgroupGroupItems[] | undefined;
  values: WorkgroupGroupItemsValues[];
}

export const getDefaultValues = (props: DefaultValueProps) => {
  const { isEdit, workgroupGroup } = { ...props };
  const {
    name,
    description,
    workgroupGroupItems,
    ...workgroupGroupFields
  } = {
    ...workgroupGroup,
  };
  let defaultValues: WorkgroupGroupValues = WORKGROUP_INITIAL_VALUES;

  if (isEdit && workgroupGroupFields) {
    defaultValues = {
      name: name || null,
      description: description || null,
      workgroupGroupItems:
        workgroupGroupItems?.nodes.map((ele) => ({
          workgroupId: ele.workgroupId,
        })) || [],
    };
  }
  return defaultValues;
};

export const getDeletedItems = (props: GroupItemsProps) => {
  const { workgroupGroupItems, values } = { ...props };
  const deletedGroupItems =
    values &&
    (differenceBy(workgroupGroupItems, values, 'workgroupId').map((item) => ({
      id: item.id,
      rowTimestamp: item._rowTimestamp,
    })) as EntityDeleteInput[]);
  return deletedGroupItems;
};

export const getNewGroupItems = (props: GroupItemsProps) => {
  const { workgroupGroupItems, values } = { ...props };
  const groupItemsArray = workgroupGroupItems?.map((ele) => ({
    workgroupId: ele.workgroupId,
  }));
  const newGroupItems =
    values.filter(
      ({ workgroupId: workgroupId1 }) =>
        !groupItemsArray?.some(
          ({ workgroupId: workgroupId2 }) => workgroupId2 === workgroupId1
        )
    ) || [];
  return newGroupItems;
};
